"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.breadcrumbsNovoDark = exports.breadcrumbsNovo = exports.breadcrumbs = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const breadcrumbs = {
    textLink: {
        textLinkColorPrimaryDisabled: color_const_1.default.pickledBluewood800,
    },
    separatorFontSize: font_const_1.default.sizeSm,
    separatorFontWeight: font_const_1.default.weightDefault,
    separatorPadding: '0 6px',
    separatorTextColor: color_const_1.default.pickledBluewood800,
};
exports.breadcrumbs = breadcrumbs;
const breadcrumbsNovo = {
    textLink: {
        textLinkColorPrimaryDisabled: novo.textColor01,
    },
    separatorFontSize: novo.body02.fontSize,
    separatorFontWeight: novo.body02.fontWeight,
    separatorPadding: '0 6px',
    separatorTextColor: novo.textColor01,
};
exports.breadcrumbsNovo = breadcrumbsNovo;
const breadcrumbsNovoDark = {
    ...breadcrumbsNovo,
    textLink: {
        textLinkColorPrimaryDisabled: novoDark.textColor01,
    },
    separatorTextColor: novoDark.textColor01,
};
exports.breadcrumbsNovoDark = breadcrumbsNovoDark;
